import React from "react";
import { Input, Form } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../utils/form";

const { TextArea } = Input;

const itemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    lg: { span: 10 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    lg: { span: 14 },
  },
};

const ControlledTextArea = ({
  control,
  errors,
  name,
  label,
  required,
  placeholder,
  disabled = false,
}) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          {...itemLayout}
          required={required}
          label={label}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
          style={{ marginBottom: 10 }}
        >
          <TextArea
            rows={2}
            {...field}
            disabled={disabled}
            placeholder={placeholder}
            //autoComplete={"nope"}
            onFocus={() => {
              let el = document.getElementsByName(name);
              el = el[0];
              el.setAttribute("autocomplete", "autocomplete_off");
              //el.setAttribute("id", `${label}_`);
            }}
          />
        </Form.Item>
      )}
    />
  );
};

export default ControlledTextArea;
